import React, { Component } from 'react';
import {PropTypes} from 'prop-types';
import {connect} from 'react-redux';
import {validatable, ShowIf} from 'components/utils';
import Select from 'react-select';
import style from './_SubCategorySelectorInput.scss';
require('fg-select-css/src/select-css.css');
require('fg-select-css/src/select-css-theme.css');
require('fg-select-css/src/select-css-arrow.css');

class GroupSubCategoryMultipleSelect extends Component {
  constructor (props, context) {
    super(props, context);

    this.state = {
      removeSelected: true,
      disabled: false,
      stayOpen: true,
      value: this.props.value,
      rtl: false,
      options: []
    };

    this.props.categories && this.props.categories.length > 0 && this.props.categories.map(category => {
      if (category.id === this.props.parentId) {
        category.children && category.children.map(subCategory => {
          this.state.options.push({
            label: subCategory.name,
            value: subCategory.id
          });
        })
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
  if (prevProps.categories != this.props.categories) {
      let options = [];
      this.props.categories && this.props.categories.length > 0 && this.props.categories.map(category => {
        if (category.id === this.props.parentId) {
          category.children && category.children.map(subCategory => {
            options.push({
              label: subCategory.name,
              value: subCategory.id
            });
          })
        }
      });

      this.setState({
        options
      });
    }
    if (prevState.value !== this.props.value) {
      this.setState({
        value: this.props.value
      })
    }
  }

  onChange(e) {
    this.setState({
      value: e || []
    }, () => this.pushData());
  }

  pushData() {
    this.props.onChange(this.state.value);
  }

  validate() {
    if (this.state.value.length === 0) {
      this.setState({
        isValid: false,
        validationText: this.props.requiredText
      });

      this.input.focus();
      return false;
    } else {
      this.setState({
        isValid: true
      });

      return true;
    }
  }

  render () {
    const { crazy, disabled, stayOpen, value, options } = this.state;
    return (
      <div className="section">
        <h3 className="section-heading">{this.props.label}</h3>

        <div className='multiple-select-wrap'>
          <Select
            ref="selector"
            closeOnSelect={false}
            disabled={disabled}
            multi
            onChange={this.onChange.bind(this)}
            options={options}
            placeholder="Chọn nhóm sản phẩm..."
            removeSelected={this.state.removeSelected}
            rtl={this.state.rtl}
            simpleValue={false}
            value={value}
          />
          <input className={ 'hidden-input' } ref={(input) => {this.input = input}}/>
          <ShowIf condition={!this.state.isValid}>
            <span className="help-block">{this.state.validationText}</span>
          </ShowIf>
        </div>
      </div>
    );
  }

}

let bindStateToProps = (state) => {
  return {
    categories: state.categoriesAsTree
  }
}

GroupSubCategoryMultipleSelect.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.string)
}

GroupSubCategoryMultipleSelect.defaultProps = {
  onChange: function() {
    console.log('You need to implement onChange method for CategorySelectorInput');
  },
  data: [],
  requiredText: 'Vui lòng chọn nhóm sản phẩm của hội chợ'
}


export default connect(bindStateToProps)(validatable(GroupSubCategoryMultipleSelect));



// WEBPACK FOOTER //
// ./components/danangtrade-forms/GroupSubCategoryMultipleSelect.jsx